module.exports = __webpack_public_path__ + "img/easy-delivery.6be44330.svg";